import { zodResolver } from '@hookform/resolvers/zod';
import { passwordResetRequestSchema } from '@erp/shared';
import { useState } from 'react';
import { useForm } from 'react-hook-form';
import { Link } from 'react-router';
import type { z } from 'zod';

import { AuthLayout } from '../../components/auth/auth-layout.tsx';
import { Alert } from '../../components/ui/alert.tsx';
import { Button } from '../../components/ui/button.tsx';
import { Field, Input } from '../../components/ui/field.tsx';
import { api, errorMessage } from '../../lib/api.ts';

export function ForgotPasswordPage() {
  const [sent, setSent] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const form = useForm<
    z.input<typeof passwordResetRequestSchema>,
    unknown,
    z.output<typeof passwordResetRequestSchema>
  >({
    resolver: zodResolver(passwordResetRequestSchema),
    defaultValues: { email: '' },
  });

  const onSubmit = form.handleSubmit(async (values) => {
    setError(null);
    try {
      await api('/auth/password-reset/request', { method: 'POST', body: values });
      setSent(true);
    } catch (err) {
      setError(errorMessage(err));
    }
  });

  return (
    <AuthLayout
      title="¿Olvidaste tu contraseña?"
      subtitle="Te enviaremos un enlace para elegir una nueva."
    >
      {sent ? (
        <Alert tone="success" title="Revisa tu correo">
          Si hay una cuenta con ese correo, te enviamos un enlace que vence en 30 minutos. Si no
          llega en unos minutos, revisa la carpeta de correo no deseado.
        </Alert>
      ) : (
        <form onSubmit={(event) => void onSubmit(event)} className="space-y-4" noValidate>
          {error && <Alert tone="danger">{error}</Alert>}
          <Field label="Correo electrónico" error={form.formState.errors.email?.message}>
            {(a11y) => (
              <Input
                {...a11y}
                type="email"
                autoComplete="email"
                inputMode="email"
                {...form.register('email')}
              />
            )}
          </Field>
          <Button
            variant="brand"
            type="submit"
            className="w-full"
            loading={form.formState.isSubmitting}
          >
            Enviar enlace
          </Button>
        </form>
      )}
      <p className="text-center text-sm">
        <Link to="/iniciar-sesion" className="text-primary underline-offset-4 hover:underline">
          Volver a iniciar sesión
        </Link>
      </p>
    </AuthLayout>
  );
}
